import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./route/AppRouter";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider } from "./context/AuthProvider";
import { PersistGate } from "redux-persist/integration/react";
import { SocketProvider } from "./context/socket.context";

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <SocketProvider>
            <Router>
              <Toaster richColors={true} position="top-right" />
              <AppRouter />
              {/* <FetchPosts /> */}
            </Router>
          </SocketProvider>
        </PersistGate>
      </Provider>
    </AuthProvider>
  );
};

export default App;
